<template>
  <v-card v-if="selected_post">
    <v-row class="ma-0">
      <!-- ====== Columna de MEDIA ====== -->
      <v-col cols="12" md="6" class="pa-0 skeleton-height2">
        <!-- Skeleton hasta que esté listo el primer media -->
        <v-skeleton-loader
          v-if="!isReady"
          type="image"
          class="skeleton-media"
        />
        <div v-show="isReady" class="media-wrapper">
          <div class="media-stage">
            <!-- Video -->
            <div
              class="video-container"
              v-if="isVideo(currentMedia)"
              @mouseenter="onVideoHover(true)"
              @mouseleave="onVideoHover(false)"
            >
              <video
                :src="fullUrl(currentMedia)"
                autoplay
                :muted="muted"
                @click="toggleMute"
                loop
                playsinline
                preload="metadata"
                @loadeddata="onFirstReady"
                class="media-el"
                ref="videoPlayer"
              ></video>

              <!-- Icono mute/unmute -->
              <div v-if="showIcon" class="mute-icon-overlay">
                <v-icon color="white">{{ muted ? 'mdi-volume-variant-off' : 'mdi-volume-high' }}</v-icon>
              </div>
            </div>


            <!-- Imagen -->
            <img
              v-else
              :src="fullUrl(currentMedia)"
              alt=""
              class="media-el"
              @load="onFirstReady"
              loading="lazy"
              decoding="async"
            />
          </div>

          <!-- Controles de carrusel (si hay más de 1 media) -->
          <div v-if="mediaList.length > 1" class="media-controls">
            <v-btn icon small @click="prevMedia" :disabled="mediaIndex === 0"><v-icon>mdi-chevron-left</v-icon></v-btn>
            <div class="dots">
              <span
                v-for="(m, i) in mediaList"
                :key="i"
                :class="['dot', { active: i === mediaIndex }]"
                @click="goMedia(i)"
              />
            </div>
            <v-btn icon small @click="nextMedia" :disabled="mediaIndex === mediaList.length - 1"><v-icon>mdi-chevron-right</v-icon></v-btn>
          </div>
        </div>
      </v-col>

      <!-- ====== Columna derecha ====== -->
      <v-col cols="12" md="6" class="px-5">
        <!-- Header influencer (con skeleton mientras renderiza) -->
        <v-row class="ma-0 mt-4" v-if="selected_post && selected_post.influencer">
          <router-link :to="{ query: { influencer_id: selected_post.influencer.id || 1 } }" style="width:100%;">
            <v-row class="ma-0 align-center" no-gutters>
              <v-avatar size="45" color="red" class="mr-4">
                <v-img :src="selected_post.influencer.profile_photo_path"/>
              </v-avatar>
              <div class="influencer-data">
                <v-card-title class="pa-0 ma-0">
                  {{ selected_post.influencer.name + (selected_post.influencer.last ? (' ' + selected_post.influencer.last) : '') }}
                </v-card-title>
                <v-card-subtitle class="pa-0 ma-0">
                  {{ selected_post.provider == "Case Study"
                      ? (selected_post.influencer && (selected_post.influencer.name + (selected_post.influencer.last ? (' ' + selected_post.influencer.last) : '')))
                      : (selected_post.influencer && selected_post.influencer.social_networks
                          ? selected_post.influencer.social_networks[selected_post.provider == "TikTok Content" ? 'tiktok' : 'instagram']
                          : ''
                        )
                  }}
                  <v-icon v-if="selected_post.provider!='Case Study'" x-small color="#0095F6">mdi-check-decagram</v-icon>
                </v-card-subtitle>
              </div>
              <v-spacer/>
              <v-img
                max-height="40"
                max-width="26"
                class="mr-4"
                :src="selected_post.influencer.department=='PEACH' ? '/PEACH-MONOGRAMA.png' : (selected_post.influencer.department == 'PLUM' ? '/PEACH-MONOGRAMA.png' : '' )"
              />
            </v-row>
          </router-link>
        </v-row>

        <!-- Métricas -->
        <v-row class="ma-0 px-8 py-6 influencer-numbers" v-if="selected_post && selected_post.influencer && selected_post.provider!='Case Study'">
          <div>
            <span class="pa-0 ma-0 title">{{selected_post.influencer[ (selected_post.provider=='TikTok Content'?'tiktok':'instagram') + '_followers'] || 0}}</span>
            <span class="pa-0 ma-0 subtitle">Seguidores</span>
          </div>
          <v-spacer/>
          <div>
            <span class="pa-0 ma-0 title">{{selected_post.influencer.social_networks.metrics!=undefined?(selected_post.influencer.social_networks.metrics[selected_post.provider=='TikTok Content'?'tiktok':'instagram'].avg_likes) : 0}}</span>
            <span class="pa-0 ma-0 subtitle">Avg. likes</span>
          </div>
          <v-spacer/>
          <div>
            <span class="pa-0 ma-0 title">{{selected_post.influencer.social_networks.metrics!=undefined?(selected_post.influencer.social_networks.metrics[selected_post.provider=='TikTok Content'?'tiktok':'instagram'].avg_comments) : 0}}</span>
            <span class="pa-0 ma-0 subtitle">Avg. Comments</span>
          </div>
        </v-row>

        <!-- Tipo + contenido -->
        <v-skeleton-loader v-if="!isReady" class="mb-2" type="chip, text@3" />
        <template v-else>
          <v-chip class="post-type" color="#F1F1F1" label>
            <v-icon small class="mr-1" v-if="selected_post.provider && selected_post.provider.toLowerCase().includes('instagram')">mdi-instagram</v-icon>
            <v-img height="15px" width="15px" class="mr-1" v-else-if="selected_post.provider && selected_post.provider.toLowerCase().includes('tiktok')" src="/tiktok-icon.png"></v-img>
            {{ selected_post.provider }}
          </v-chip>

          <v-card-text class="post-content px-0">
            <strong>{{ selected_post.title }}</strong>{{ ' ' + (selected_post.caption || '') }}
          </v-card-text>

          <div class="post-tags">
            <a v-for="(tag, index) in (selected_post.tags || [])" :key="index">{{'#' + tag + ' '}}</a>
          </div>
        </template>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: 'Post',
  props: {
    selected_post: { type: Object, required: true },
    posts: { type: Array, default: () => [] },
    selectedIndex: { type: Number, default: -1 }
  },
  data () {
    return {
      muted: true,
      showIcon: false,
      iconTimeout: null,
      FILES_BASE_URL: 'https://peach.blitzhub.mx/files/',
      isReady: false,
      mediaIndex: 0
    }
  },
  computed: {
    mediaList () {
      const arr = Array.isArray(this.selected_post && this.selected_post.media)
        ? this.selected_post.media
        : []
      return arr
    },
    currentMedia () {
      return this.mediaList.length ? this.mediaList[this.mediaIndex] : null
    },
  },
  watch: {
    selected_post: {
      immediate: true,
      handler () {
        this.mediaIndex = 0
        this.isReady = false
      }
    }
  },
  beforeDestroy () {
    if (this.iconTimeout) clearTimeout(this.iconTimeout)
  },
  methods: {
    // Muestra el ícono durante X ms
    showMuteIcon (duration = 1000) {
      this.showIcon = true
      if (this.iconTimeout) clearTimeout(this.iconTimeout)
      this.iconTimeout = setTimeout(() => {
        this.showIcon = false
      }, duration)
    },

    toggleMute () {
      this.muted = !this.muted
      // feedback al hacer click: mostrar ícono 1s
      this.showMuteIcon(1000)
    },

    // Se dispara cuando el media (imagen o video) ya está listo
    onFirstReady () {
      if (!this.isReady) this.isReady = true

      // Si es video, mostrar un hint inicial de mute 1.5s
      if (this.isVideo(this.currentMedia)) {
        this.showMuteIcon(1500)
      }
    },

    // Hover en desktop: mostrar ícono mientras está el mouse encima
    onVideoHover (enter) {
      if (enter) {
        // mientras hay hover, mantenlo visible
        if (this.iconTimeout) clearTimeout(this.iconTimeout)
        this.showIcon = true
      } else {
        // al salir, que se desvanezca luego de un pequeño delay
        this.showMuteIcon(400)
      }
    },

    fullUrl (path) {
      if (!path) return ''
      return /^https?:\/\//i.test(path) ? path : (this.FILES_BASE_URL + path)
    },
    isVideo (path) {
      return /\.mp4($|\?)/i.test(path || '')
    },
    closeDialog () {
      this.$emit('closeDialog')
    },
    // Carrusel interno del post
    nextMedia () {
      if (this.mediaIndex < this.mediaList.length - 1) this.mediaIndex++
    },
    prevMedia () {
      if (this.mediaIndex > 0) this.mediaIndex--
    },
    goMedia (i) {
      if (i >= 0 && i < this.mediaList.length) this.mediaIndex = i
    }
  }

}
</script>

<style>
/* Skeleton media */
.skeleton-media{
  width: 100%;
  height: 320px;
  border-radius: 8px;
}

/* Contenedor del media */
.media-wrapper{
  position: relative;
  width: 100%;
  height: auto;
  background: #000;
}

/* Stage del media */
.media-stage{
  position: relative;
  width: 100%;
  height: auto;
}
.media-el{
  width: 100%;
  height: auto;
  display: block;
}

/* Controles de carrusel */
.media-controls{
  position: absolute;
  left: 0; right: 0;
  bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  z-index: 2;
  pointer-events: none;
}
.media-controls .v-btn{
  pointer-events: all;
  background: rgba(0,0,0,.5);
  color: #fff !important;
}
.dots{ display: inline-flex; gap: 6px; pointer-events: all; }
.dot{
  width: 6px; height: 6px; border-radius: 50%;
  background: rgba(255,255,255,.5);
  cursor: pointer;
}
.dot.active{ background: #fff; }

/* Flechas para navegar entre POSTS del grid */
.post-nav{
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 3;
  width: 36px; height: 36px; border-radius: 50%;
  border: none;
  display: grid; place-items: center;
  background: rgba(0,0,0,.55);
  color: #fff;
  cursor: pointer;
}
.post-nav--left{ left: 8px; }
.post-nav--right{ right: 8px; }

/* Parte derecha */
.influencer-data .v-card__title{
  font-size:15px!important;
  font-weight: 400!important;
  line-height: 20px;
  color:black!important;
}
.influencer-data .v-card__subtitle{
  font-size:14px!important;
  color:black!important;
  font-weight: 700!important;
}
a:-webkit-any-link { text-decoration: none!important; }
.influencer-numbers .title{
  font-size:15px!important;
  line-height: 15px;
}
.influencer-numbers .subtitle{
  font-size:12px!important;
  font-weight: 400!important;
}
.influencer-numbers div{
  text-align: center!important;
  display: grid;
}
.post-content, .post-tags{ font-size:13px!important; }
.post-type{
  font-weight: 400!important;
  font-size:12px!important;
  border-radius: 5px !important;
  height: 26px !important;
}
.quotation-button{
  font-size:14px!important;
  font-weight: 500!important;
  padding:20px;
  letter-spacing: 0;
  height:36px!important; width:146px!important;
}

/* Mute overlay */
.video-container { position: relative; width: 100%; height: auto; }
.mute-icon-overlay{
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(50, 50, 50, 0.90);
  color: white;
  border-radius: 50%;
  padding: 8px 12px 12px;
  font-size: 30px;
  opacity: 1;
  transition: opacity 0.3s ease-out;
  pointer-events: none;
}

.video-container .v-icon.v-icon {
    font-size: 42px!important;
}

.skeleton-height2 .v-skeleton-loader__image, .skeleton-media{
  height: 67vw!important
}
</style>
